/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css } from '@emotion/react';
import { getResource } from '../../language/resources/getResource';
import { LargeText, UNSELECTABLE_TEXT } from '../../styles/styles';
import { DARK_GREY, RED_CREEK } from '../../styles/colors';
import paymentLogo from '../../assets/icons/payWithPass.svg'
import { PaymentMethod } from './paymentMethod';

const paymentMethodRoot = css`
  margin-top: 25px;
  margin-bottom: 25px;
  display: flex;
  flex-direction: row;
`;

const detailContainer = css`
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 25px;
  display: grid;
`;

const detailStyle =css`
  ${LargeText}; 
  color: ${DARK_GREY};
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  display: block;
`;

const expiredText = css`
  color: ${RED_CREEK};
  ${LargeText}; 
`

const logoContainer = css`
  width: 140px;  
  overflow: hidden;
`;

const paymentLogoStyle = css`
  width: 100%;
  height: 100%;
  ${UNSELECTABLE_TEXT};
`;


/**
 * PaymentMethodView: a component to display basic payment method info.
 */
export default class PaymentMethodView extends React.PureComponent<{
    resources: Record<string, any>;
    paymentMethod: PaymentMethod
  }> {
    public render = () => {
      const expirationDate =
        this.props.paymentMethod.expirationDate instanceof Date
      ? this.props.paymentMethod.expirationDate
      : new Date(this.props.paymentMethod.expirationDate);

      return (
      <div css={paymentMethodRoot}>
        {/* Logo */}
        <div css={logoContainer}>
            <img src={paymentLogo}
                alt='Logo'
                css={paymentLogoStyle}/>
        </div>

        <div css={detailContainer}>
            {/* Name on card */}
            <span 
                css={detailStyle}
                title={this.props.paymentMethod.nameOnCard}>{this.props.paymentMethod.nameOnCard}
            </span>

            {/* CC Last Four */}
            <span css={detailStyle}>{`xxxx xxxx ${this.props.paymentMethod.ccLastFour}`}</span>

            {/* Expiry */}
            <span css={detailStyle}>{getResource(this.props.resources, 'PAYMENT_REGISTRATION_EXPIRY', 
                this.props.paymentMethod.expiryMonth, 
                this.props.paymentMethod.expiryYear)}
            </span>

            {/* Expiration alert */}
            {/*expirationDate < new Date() && 
            <span css={expiredText}>{getResource(this.props.resources, 'PAYMENT_REISTRATION_EXPIRED')}</span>}*/}
        </div>
        
      </div>
    )}
  };
  